<template lang="pug">
div
    v-card.mt-3.transparent(style="backdrop-filter:blur(10px);")
        v-card-text(style="background-color:rgba(0,0,0,0.1);")
            v-form(v-model="validateUploadForm")
                v-layout(row wrap)
                    v-flex(xs12).text-center.pt-1
                        h3 Datos del trabajador asegurado
                    v-flex(xs12)
                        v-text-field(
                            label="CI (Numero de documento):"
                            outlined
                            v-mask="'cccccccccccc'"
                            :rules="$rules.ci"
                            v-model="dataUploadDec.ci"
                            autocomplete="off"
                            ref="refsUploadDecCi"
                            :hide-details="refsUploadDec.ci"
                            @update:error="refsUploadDec.ci = $refs.refsUploadDecCi.valid"
                            @blur="refsUploadDec.ci = $refs.refsUploadDecCi.valid"
                            @keydown="refsUploadDec.ci = $refs.refsUploadDecCi.valid")
                    v-flex(xs12)
                        v-text-field(label="Nombres:" outlined hide-details)
                    v-flex(xs6)
                        v-text-field(label="Apellido Paterno:" outlined hide-details)
                    v-flex(xs6)
                        v-text-field(label="Apellido Materno:" outlined hide-details)
                    v-flex(xs6)
                        v-text-field(label="Item:" outlined hide-details)
                    v-flex(xs6)
                        v-text-field(label="Servicio:" outlined hide-details)
                    v-flex(xs6)
                        v-select(
                            :items="$timer.getYears(1970,2019)"
                            outlined
                            label="Mes:"
                            v-model="dataUploadDec.anio"
                            hide-details)
                    v-flex(xs6)
                        v-select(
                            :items="$timer.getYears(1970,2019)"
                            outlined
                            label="Cuota:"
                            v-model="dataUploadDec.anio"
                            hide-details)
                    v-flex(xs12)
                        h4.pb-2 Tipo subsidio:
                        v-radio-group(row hide-details).no-margin
                            v-radio(label="Prenatal").mb-2.mr-7
                            v-radio(label="Natalidad").mb-2.mr-7
                            v-radio(label="Lactancia").mb-2.mr-7
                            v-radio(label="Defuncion").mb-2.mr-7
        v-card-actions(style="background-color:rgba(0,0,0,0.1);").mb-2
            v-spacer
            v-btn.success.txtn(large :loading="isLoading" @click="subirArchivoDec") Generar solicitud&nbsp;
                v-icon fas fa-file-alt
            v-spacer
    v-card.transparent.mt-5(style="backdrop-filter:blur(10px);")
        v-card-text(style="background-color:rgba(0,0,0,0.1);")
            | Puede consultar sus formularios de solicitudes generados ingresando su CI:
        v-card-text.pt-1(style="background-color:rgba(0,0,0,0.1);")
            v-text-field(label="CI (Numero de documento):" outlined hide-details v-mask="'cccccccccccc'")
                template(v-slot:append-outer)
                    v-btn(color="success" @click="dialogUltimosDec=true" style="margin-top:-5px").txtn Verificar
    v-dialog(v-model="dialogConfirm" width=400)
        v-card
            v-toolbar(dark color="success" dense).no-padding.no-margin
                v-toolbar-title Archivo subido.
                v-spacer
                v-btn(icon dark @click="dialogConfirm = false")
                    v-icon fas fa-times
            v-card-text.text-center.pb-5
                h3.pt-3 Su archivo fué subido correctamente al servidor, puede verificarlo mas adelante con su ci:
                h3.pt-2 4687156
                v-btn(color="success" @click="dialogConfirm = false").mt-2 Aceptar
</template>
<script>
export default {
    data() {
        return {
            dataUploadDec: {
                ci: null,
                mes: null,
                anio: null,
                dec: null
            },
            dialogConfirm: false,
            isLoading: false,
            validateUploadForm: false,
            refsUploadDec: {
                ci: true,
                dec: true
            }
        }
    },
    computed: {
        //
    },
    mounted() {
        //this.ciDetails = true
    },
    methods: {
        async subirArchivoDec(){
            try{
                // Check form validation
                // check captcha
                // init progress in button
                let response = await axios({
                    method: 'post',

                })
                // stop progress in button
                console.log('Data', this.dataUploadDec)
            }
            catch(e){
                this.$snotify.info('Error catch')
                // stop progress in button
            }
        }
    }
}
</script>